import { render, staticRenderFns } from "./BlankPreview.vue?vue&type=template&id=09952a1c&scoped=true&"
import script from "./BlankPreview.vue?vue&type=script&lang=js&"
export * from "./BlankPreview.vue?vue&type=script&lang=js&"
import style0 from "./BlankPreview.vue?vue&type=style&index=0&id=09952a1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09952a1c",
  null
  
)

export default component.exports